
export const colours = {
  dark: 'hsl(218, 12%, 18%)',
  midDark: 'hsl(218, 12%, 30%)',
  lightDark: 'hsl(218, 12%, 40%)',
  light: 'hsl(218, 12%, 95%)',
  midLight: 'hsl(218, 12%, 80%)',
  primary: 'steelblue',
  // secondary: '',
  currentTime: 'firebrick',
}